<template>
  <el-dialog
    :title="modalType === 'add' ? '添加产品' : '编辑产品'"
    :visible.sync="visible"
    width="422px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-form-item label="产品名称：" prop="appName">
        <el-input placeholder="请输入产品名称" v-model="ruleForm.appName"></el-input>
      </el-form-item>
      <el-form-item label="包名：" prop="pkg">
        <el-input placeholder="请输入包名" v-model="ruleForm.pkg"></el-input>
      </el-form-item>
      <el-form-item label="DBT id：" prop="dbtId">
        <el-input placeholder="请输入DBT id" v-model="ruleForm.dbtId"></el-input>
      </el-form-item>
      <el-form-item label="渠道：" prop="platType">
        <el-select style="width: 100%" v-model="ruleForm.platType" placeholder="请选择渠道">
          <el-option label="今日头条" :value="1"></el-option>
          <el-option label="快手" :value="3"></el-option>
          <el-option label="广点通" :value="2"></el-option>
          <el-option label="OPPO" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告主id：" prop="advertiserId">
        <el-input placeholder="请输入广告主id" v-model="ruleForm.advertiserId"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="saveForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addConvertProduct, modifyConvertProduct } from "@/api/tools";
export default {
  data() {
    return {
      ruleForm: {
        appName: "",
        pkg: "",
        dbtId: "",
        platType: "",
        advertiserId: "",
        id: "",
      },
      visible: false,
      afAccountList: [],
      modalType: "",
      rules: {
        appName: [
          {
            required: true,
            message: "请输入产品名称",
            trigger: ["blur"],
          },
        ],
        pkg: [
          {
            required: true,
            message: "请输入包名",
            trigger: ["blur"],
          },
        ],
        dbtId: [
          {
            required: true,
            message: "请输入DBT id",
            trigger: ["blur"],
          },
        ],
        platType: [
          {
            required: true,
            message: "请选择渠道",
            trigger: ["blur"],
          },
        ],
        advertiserId: [
          {
            required: true,
            message: "请输入广告主id",
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  methods: {
    showModal(type, data) {
      this.modalType = type;
      if (type === "edit") {
        const { appName, pkg, dbtId, platType, advertiserId, id } = data;
        this.ruleForm = {
          appName,
          pkg,
          dbtId,
          platType,
          advertiserId,
          id,
        };
      } else {
        this.ruleForm = {
          appName: "",
          pkg: "",
          dbtId: "",
          platType: "",
          advertiserId: "",
          id: "",
        };
      }
      this.visible = true;
    },
    cancelForm() {
      this.visible = false;
    },
    saveForm(formName) {
      this.$emit("showLoading");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.modalType === "add") {
            addConvertProduct({ ...this.ruleForm }).then(() => {
              this.visible = false;
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.$emit("successCallback");
            });
          } else {
            modifyConvertProduct({ ...this.ruleForm }).then(() => {
              this.visible = false;
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.$emit("successCallback");
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.demo-ruleForm {
  .is-required {
    /deep/ .el-form-item__label::before {
      content: "*";
      display: inline-block;
      color: red;
      margin-right: 4px;
    }
  }
}
</style>
